<template>
    <div class='gold-page'>
        <div class="common-title">祺信详情</div>
        <div class="page-main no-shadow shadow-box">
            <goldDetail :goldData="pageData" />
            <!-- <div class="spaceBetween">
                <div>
                    <div class="gold-line">开立日：{{ pageData.estbDay | dateFormat('YYYY-mm-dd') }}</div>
                    <div class="gold-line">到期日：{{ pageData.exDay | dateFormat('YYYY-mm-dd') }}</div>
                </div>
                <div style="font-weight:bold;font-size:18px;position: relative;left:20px;">祺信</div>
                <div>
                    <div class="gold-line">状态：
                        {{ pageData.isPledged == 1 ? (pageData.pledgeStatus | pledgeStatus)
                            : pageData.gldStCd | GbGldStCdTrans }}
                    </div>
                    <div class="gold-line">编号：{{ pageData.gldId }}</div>
                </div>
            </div>
            <table class="gold-detail-table">
                <tr v-if="pageData.isPledged != 1">
                    <td>流转方</td>
                    <td>{{ pageData.pyptNm }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.pyptOrgCode }}</td>
                </tr>
                <tr v-if="pageData.isPledged != 1">
                    <td>接收方</td>
                    <td>{{ pageData.rcPtyNm || pageData.tenantNm || pageData.tenantName }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.rcPtyOrgCode || pageData.tenantOrgCode }}</td>
                </tr>
                <tr>
                    <td>开立方</td>
                    <td>{{ pageData.estbNm }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.estbOrgCode }}</td>
                </tr>
                <tr v-if="pageData.grtStCd == 2">
                    <td>保证人</td>
                    <td>{{ pageData.guarantorName }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.guarantorOrgCode }}</td>
                </tr>
                <tr v-if="pageData.isPledged == 1">
                    <td>出质人</td>
                    <td>{{ pageData.pledgorNm }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.pledgorOrgCode }}</td>
                </tr>
                <tr v-if="pageData.isPledged == 1">
                    <td>质权人</td>
                    <td>{{ pageData.pledgeeName }}</td>
                    <td>统一社会信用代码</td>
                    <td>{{ pageData.pledgeeOrgCode }}</td>
                </tr>
                <tr>
                    <td colspan="4" style="height:50px;">
                        <span>祺信金额</span>
                        <span style="margin-left:60px;">(大写){{ pageData.bigGldAmt }}</span>
                        <span style="margin-left:160px;">(小写)¥{{ pageData.gldAmt | splitK }}</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="4">
                        <span>
                            开立方声明：我司已对本祺信出具《付款承诺函（{{ pageData.firstGldId }}
                            ）》，到期无条件依据持票方明细付款。 承诺日期：{{ pageData.signTime | dateFormat('YYYY-mm-dd') }}
                        </span>
                    </td>
                </tr>
                <tr v-if="+pageData.isPledged !== 1">
                    <td colspan="4" class="detail-table__remarks">
                        <span v-if="+pageData.canBeModified === 0">备注：本祺信可以全部或部分流转支付<span
                                v-if="pageData.firstGldId !== pageData.gldId">，也可以随时申请融资</span>。</span>
                        <span v-if="+pageData.canBeModified === 1 || +pageData.canBeModified === 3">备注：本祺信可以全部或部分流转支付<span
                                v-if="pageData.firstGldId !== pageData.gldId">，也可以随时申请融资</span>。<b>开立方可对本祺信的到期日期进行变更，变更后的祺信到期日期将早于{{ pageData.exDay
                                    | dateFormat('YYYY-mm-dd') }}。</b></span>
                        <span v-if="+pageData.canBeModified === 2">备注：本祺信可以全部或部分流转支付<span
                                v-if="pageData.firstGldId !== pageData.gldId">，也可以随时申请融资</span>。<b>开立方已于{{ pageData.modifiedDay
                                    |
                                    dateFormat('YYYY-mm-dd') }}，将到期日期由{{ pageData.beforeModified | dateFormat('YYYY-mm-dd') }}变更为{{ pageData.afterModified | dateFormat('YYYY-mm-dd') }}。</b></span>
                    </td>
                </tr>
                <tr v-if="+pageData.isPledged === 1">
                    <td colspan="4" class="detail-table__remarks">
                        <span>备注：本祺信已质押,清分款项需先用于偿还出质人的债务.</span>
                    </td>
                </tr>
            </table> -->
            <!-- 已融资的祺信展示下方 -->
            <!-- <div class="spaceBetween" style="margin-top:10px;" v-if="$route.query.isGldLend">
                <div>
                    <div class="gold-line">流转方财务记账建议：</div>
                    <div class="gold-line">借：银行存款</div>
                    <div class="gold-line" style="margin-left:28px">财务费用</div>
                </div>
                <div>
                    <div class="gold-line"></div>
                    <div class="gold-line">贷：应收账款-祺信({{ pageData.gldId }}） </div>
                </div>
            </div>
            <div class="spaceBetween" style="margin-top:10px;" v-else>
                <div>
                    <div class="gold-line">流转方财务记账建议：</div>
                    <div class="gold-line">借：应付账款-{{ pageData.rcPtyNm || pageData.tenantNm || pageData.tenantName }} </div>
                    <div class="gold-line">贷：应付账款-祺信({{ pageData.gldId }}） </div>
                </div>
                <div>
                    <div class="gold-line">接收方财务记账建议：</div>
                    <div class="gold-line">借：应收账款-祺信({{ pageData.gldId }}） </div>
                    <div class="gold-line">贷：应收账款-{{ pageData.pyptNm }} </div>
                </div>
            </div> -->

            <div class="gold-btns spaceCenter">
                <a-button @click="download" class="btn-blue-line-detail">付款承诺函</a-button>
                <!-- v-if="$route.query.isGluarantee" -->
                <a-button v-if="goldData.guaranteeJingBan" @click="toTransferContractCheck(goldData)"
                    class="btn-blue-line-detail">连带责任担保函</a-button>
                <a-button @click="downloadTransferAgreement"
                    v-if="lawForDetail.showType && lawForDetail.contractType == 11"
                    class="btn-blue-line-detail">祺信转让协议</a-button>
                <a-button @click="downloadFinancingAgreement"
                    v-if="lawForDetail.showType && lawForDetail.contractType == 10"
                    class="btn-blue-line-detail">祺信融资协议</a-button>
                <a-button @click="openGuarantee" v-if="pageData.grtStCd === 2"
                    class="btn-blue-line-detail">祺信保证函</a-button>
            </div>
        </div>

        <div v-if="pageData.grtStCd == 2">担保附件</div>
        <ul v-if="pageData.grtStCd == 2">
            <li v-for="(item, index) in filesList" :key="index">
                <a href="javascript: void(0)" @click="downFile(item)">
                    {{ item.fileNm }}
                </a>
            </li>
        </ul>
        <!-- false 隐藏 -->
        <div class="common-title" v-if="false">区块信息</div>
        <div class="page-main no-shadow" v-if="false">
            <a-row>
                <a-col :span="12">
                    <p>区块编号：{{ gldBlockInfo.blcokNumber ? gldBlockInfo.blcokNumber : '--' }}</p>
                </a-col>
                <a-col :span="12">
                    <p>交易时间： {{ gldBlockInfo.transDate ? gldBlockInfo.transDate : '--' }}
                        <!-- <span v-if="gldBlockInfo.transDate">{{ gldBlockInfo.transDate | dateFormat('YYYY-mm-dd HH:MM:SS') }}</span>
                        <span v-else>--</span> -->
                    </p>
                </a-col>
                <a-col :span="12">
                    <p>区块哈希：{{ gldBlockInfo.hash ? gldBlockInfo.hash : '--' }}</p>
                </a-col>
                <a-col :span="12">
                    <p>前序区块哈希：{{ gldBlockInfo.preHash ? gldBlockInfo.preHash : '--' }}</p>
                </a-col>
            </a-row>
        </div>
        <a-modal :bodyStyle="{ height: '540px', overflow: 'auto' }" width="80%" title="协议" :visible="modalShow"
            :footer="null" @cancel="modalCancel">
            <div v-html="modalHtml"></div>
        </a-modal>
        <a-modal :bodyStyle="{ height: '540px', overflow: 'auto' }" width="80%" title="连带责任担保函"
            :visible="showTransferContract" :footer="null"
            @cancel="showTransferContract = false; transferContractHtml = ''">
            <div v-html="transferContractHtml ? transferContractHtml : ''"></div>
        </a-modal>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex"
import { getDetailApi, getLawForDetail, getGldBlockInfo } from '@/api/gold.js'
import { fileQueryAPI } from '@/api/file.js'
import { guaranteeLawTxtAPI } from '@/api/guarantee.js'
import { queryGoldguaranteeContract } from "@/api/review.js"
import goldDetail from '@/components/gold-details-basic'
export default {
    components: { goldDetail },
    props: {
        goldData: {
            type: Object
        }
    },
    name: "gold-detail-table",
    data() {
        return {
            pageData: this.goldData,
            lawForDetail: {},
            filesList: [],
            modalShow: false,
            modalHtml: "",
            gldBlockInfo: {},
            showTransferContract: false,
            transferContractHtml: ''
        }
    },
    computed: {
        way() {
            if (this.parentData) {
                return this.parentData.way;
            }
            return this.$route.params.way;
        },
        gldId() {
            if (this.parentData && this.parentData.way == 'rcvb') {
                return this.parentData.goldObj.gldId;
            }
            if (this.parentData) {
                return this.parentData.gldId;
            }
            return this.$route.params.gldId;
        },
        ...mapGetters({
            userObj: "home/getUserObj",
            parentData: "app/getGoldDetailPrarms"

        })
    },
    created() {
        // this.getGoldDetail();

        if (this.way == 'rcvb') return;
        this.getLawForDetail();
        this.getGldBlockInfo();
    },
    mounted() { },
    methods: {
        ...mapMutations({
            setBuyOrSell: "app/setBuyOrSell",
        }),
        toTransferContractCheck(record) {
            let params = {
                gldId: record.gldId,
                rcPtyNm: record.rcPty.customerName,
                estbNm: record.guarantorName,
                estbDay: record.estbDay,
                exDay: record.exDay,
                rcPty: record.rcPty.cstId,
                guaranteeName: record.guaranteeName,
                gldAmt: record.gldAmt,
            }

            queryGoldguaranteeContract({ ...params }, true)
                .then((res) => {
                    this.transferContractHtml = res.data.contractContent;
                    this.showTransferContract = true;
                })
                .catch((err) => {
                    console.log(err);
                })
        },
        // getGoldDetail(){
        //     if(this.way == 'rcvb'){
        //         this.getGoldDetailRcvb();
        //         return;
        //     }
        //     let param = {
        //         way:this.way,
        //         gldId:this.gldId
        //     }
        //     getDetailApi(param,true)
        //     .then(res => {
        //         this.pageData = res.data;
        //         let type = 'seller'
        //         if(this.userObj.cstIds.indexOf(this.pageData.estb) > -1){
        //             type = "buyer"
        //         }
        //         this.setBuyOrSell(type);
        //     }).catch(err => { console.log(err);});
        // },
        // getGoldDetailRcvb(){ //融资页面点击查看祺信详情
        //     let param = {...this.parentData.goldObj}
        //     getDetailApi(param,true)
        //     .then(res => {
        //         this.pageData = res.data;
        //     }).catch(err => { console.log(err);});
        // },
        getGldBlockInfo() {
            getGldBlockInfo(this.gldId).then(res => {
                this.gldBlockInfo = res.data
            })
        },
        getLawForDetail() {
            let param = {
                gldId: this.gldId
            }
            getLawForDetail(param)
                .then(res => {
                    this.lawForDetail = res.data || {};
                }).catch(err => { console.log(err); });
        },
        getFileList() {
            const param = {
                mdlId: '10114',
                tblBlId: this.pageData.grtId
            }
            fileQueryAPI(param)
                .then(res => {
                    this.filesList = res.data;
                }).catch(err => { console.log(err); });
        },
        modalOpen(modalHtml) {
            this.modalHtml = modalHtml || "";
            this.modalShow = true;
        },
        modalCancel() {
            this.modalShow = false;
            this.modalHtml = "";
        },
        downFile(row) {
            const DOWNLOAD_PREFIX = '/gb-bigtree-file/download/fileDownload/install';
            window.open(`${DOWNLOAD_PREFIX}${row.fileRte}/${row.fileNm}`, '_blank');
        },
        download() {
            if (+this.pageData.showType === 2) {
                this.modalOpen(this.pageData.contractContent);
            }
            else if (+this.pageData.showType === 1) {
                location.href = process.env.VUE_APP_BASE_API + `/user/lawTxt/download/${this.pageData.payPromiseFileId}`;
            }
        },
        downloadTransferAgreement() {
            if (+this.lawForDetail.showType === 2) {
                this.modalOpen(this.lawForDetail.contractContent);
            }
            else if (+this.lawForDetail.showType === 1) {
                location.href = process.env.VUE_APP_BASE_API + `/user/lawTxt/download/${this.lawForDetail.contractFileId}`;
            }
        },
        downloadFinancingAgreement() {
            if (+this.lawForDetail.showType === 2) {
                this.modalOpen(this.lawForDetail.contractContent);
            } else if (+this.lawForDetail.showType === 1) {
                location.href = process.env.VUE_APP_BASE_API + `/user/lawTxt/download/${this.lawForDetail.contractFileId}`;
            }
        },
        openGuarantee() {
            guaranteeLawTxtAPI({ grtId: this.pageData.grtId })
                .then(res => {
                    location.href = process.env.VUE_APP_BASE_API + `/user/lawTxt/download/${res.data.contractFileId}`;
                    this.modalOpen(res.data.artcCntnt);
                }).catch(err => {
                    this.$message.error(res.description);
                });
        }

    },
    watch: {
        goldData(newVal) {
            this.pageData = newVal;
        }
    },
    activated() { }
}
</script>
<style scoped>
.gold-page {
    margin-top: 20px;
}

.shadow-box {
    padding: 0 0 10px !important;
}

.gold-line {
    margin-bottom: 4px;
    color: #737F8E;
}

.gold-detail-table {
    width: 100%;
    font-family: MicrosoftYaHei;
    border-collapse: collapse;
    padding: 0;
    font-weight: normal;
    color: #0D253E;
    letter-spacing: 0;
    border: 1px solid #E2ECF7;
}

.gold-detail-table td {
    padding: 10px 15px;
    box-sizing: border-box;
    border: 1px solid #E2ECF7;
}

.gold-detail-table td:first-child {
    padding-left: 53px;
    width: 140px;
}

.gold-detail-table td:nth-child(3) {
    width: 150px;
}

.gold-btns {
    margin: 10px 0 8px 0;
}

.gold-btns button {
    margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-detail-table.vue